<div class="maintenance-shell">
  <aside class="maintenance-sidebar" [class.maintenance-sidebar--open]="menuOpen()">
    <div class="maintenance-brand">
      <span>{{ initials() }}</span>
      <div>
        <strong>{{ orgName() }}</strong>
        <small>Maintenance</small>
      </div>
    </div>

    @if (workspaces.length > 1) {
      <label class="maintenance-workspace-switcher">
        <small>Workspace</small>
        <select [value]="currentOrgId" (change)="switchWorkspace($any($event.target).value)" aria-label="Switch workspace">
          @for (org of workspaces; track org.orgId) {
            <option [value]="org.orgId" [selected]="org.orgId === currentOrgId">{{ org.orgName }}</option>
          }
        </select>
      </label>
    }

    <nav class="maintenance-nav" aria-label="Maintenance navigation">
      @for (item of navItems; track item.route) {
        <a
          [routerLink]="item.route"
          routerLinkActive="maintenance-nav__item--active"
          [routerLinkActiveOptions]="{ exact: item.route === '/dashboard' }"
          class="maintenance-nav__item"
          (click)="closeMenu()"
        >
          <span class="material-symbols-outlined" aria-hidden="true">{{ item.icon }}</span>
          {{ item.label }}
        </a>
      }
    </nav>

    <div class="maintenance-sidebar__footer">
      <a routerLink="/settings" routerLinkActive="maintenance-nav__item--active" class="maintenance-nav__item" (click)="closeMenu()">
        <span class="material-symbols-outlined" aria-hidden="true">settings</span>
        Settings
      </a>
      <button type="button" class="maintenance-nav__item" (click)="signOut()">
        <span class="material-symbols-outlined" aria-hidden="true">logout</span>
        Sign out
      </button>
    </div>
  </aside>

  <main class="maintenance-main">
    <header class="maintenance-topbar">
      <button type="button" class="maintenance-icon-button maintenance-topbar__menu" (click)="menuOpen.set(!menuOpen())" aria-label="Toggle navigation">
        <span class="material-symbols-outlined" aria-hidden="true">menu</span>
      </button>
      <div>
        <strong>{{ orgName() }}</strong>
        <small>Service operations access</small>
      </div>
      <button type="button" class="maintenance-icon-button" (click)="toggleTheme()" aria-label="Toggle dark mode">
        <span class="material-symbols-outlined" aria-hidden="true">contrast</span>
      </button>
    </header>

    <router-outlet />
  </main>
</div>
